import React, { memo } from 'react';
import MarketingCampaignsList from './contents/MarketingCampaignsList';

const Content = memo(() => {
    return (
        <div className="marketing-campaigns__content">
            <MarketingCampaignsList />
        </div>
    );
});

export default memo(Content);
